import React, { useState, useEffect } from "react";
import HistoryDate from "./Common/HistoryDate";
import VehicleHistoryItemGrid from "./Common/VehicleHistoryItemGrid";
import VehicleHistoryItem from "./Common/VehicleHistoryItem";
import InfiniteScroll from "react-infinite-scroll-component";
import IconButton from "@material-ui/core/IconButton";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import { isMobile } from "react-device-detect";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { useRecoilState } from 'recoil';

import HistoryItemsMobileWrapper from "./Wrapper/HistoryItemsMobileWrapper";
import HistoryItemsPCWrapper from "./Wrapper/HistoryItemsPCWrapper";
import useWindowSize from "../../../../../core/hooks/useWindowSize";


import { VehicleHistoryDateState } from '../store/VehicleHistoryDateStore';

const HistoryList = (props) => {
  //const classes = useStyles();
  const {
    vehicle,
    items,
    hasMore,
    selectedVehicle,
    clickedVehicle,
    fetchMoreData,
    exportData,
    closeHistoryView,

  } = props;


  //console.log("HistoryList.items", items);
  const windowSize = useWindowSize();
  const [buttonText, setbuttonText] = useState(
    <VisibilityOffIcon displayname="VisibilityOffIcon" />
  );
  const [vehicleHistoryDate,] = useRecoilState(VehicleHistoryDateState);

  useEffect(() => {
    if (document?.querySelector(".perfect-scrollbar")) {
      const container = document.querySelector(".perfect-scrollbar");
      container.scrollTop = 0;
    }
  }, [vehicleHistoryDate]);


  useEffect(() => {
    try {
      const perfectScrollbar = new PerfectScrollbar(".perfect-scrollbar", {
        wheelSpeed: 0.2,
        minScrollbarLength: 40,
      });
      perfectScrollbar.update();
    } catch (_ex) {
      //console.log('err===', _ex);
    }

    return (perfectScrollbar) => {
      if (perfectScrollbar) {
        perfectScrollbar.destroy();
        perfectScrollbar = null;
      }
    };
  }, [items]);



  const handler = () => {
    if (buttonText.props.displayname === "VisibilityOffIcon")
      setbuttonText(<VisibilityIcon displayname="VisibilityIcon" />);
    else setbuttonText(<VisibilityOffIcon displayname="VisibilityOffIcon" />);
    //Don't use. Due to add collapsed class is animated
    // if(inputRef.current.classList.contains('collapsed') )
    //   setbuttonText('SHOW');
    // else
    //   setbuttonText('HIDE');
  };

  //useEventListener('click', handler, inputRef.current);


  const getExportButton = () => {
    return (
      <Tooltip title="Export history to CSV" aria-label="export">
        <IconButton onClick={exportData}>
          <SaveAltIcon />
        </IconButton>
      </Tooltip>
    );
  };


  const getShowButton = () => {
    return (
      <Tooltip title="History list" aria-label="Vehicles">
        <IconButton
          onClick={handler}
          className="vehicle-collapse"
          data-toggle="collapse"
          data-target="#collapseExample"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
          {buttonText}
        </IconButton>
      </Tooltip>
    );
  };

  const getHistoryDate = () => {
    return (
      <HistoryDate

        isMobile={isMobile}
      />
    );
  };

  const getCloseButton = () => {
    return (
      <Tooltip title="Close" aria-label="Close">
        <IconButton
          color="secondary"
          aria-label="Close"
          onClick={closeHistoryView}
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>
    );
  };

  const getInfo = () => {
    return vehicle.VehiclePlate + "-" + vehicle.VehiclePlate;
  };



  const getVehicleView = () => {

    if (isMobile && windowSize.width <= 1025) {
      return (
        <HistoryItemsMobileWrapper
          showButton={getShowButton()}
          historyDate={getHistoryDate()}
          close={getCloseButton()}
          infoStr={getInfo()}
          exportButton={getExportButton()}
        >
          {items &&
            <InfiniteScroll
              dataLength={items.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={<div>Loading...</div>}
              scrollableTarget="collapseExample"
              endMessage={
                <p style={{ textAlign: "center" }}>
                  <b>{items.length > 0 ? "End of records" : "No history record"}</b>
                </p>
              }
            >
              <ul>
                {items.map((item) => (
                  <VehicleHistoryItem
                    key={item.ReadingId}
                    item={item}
                    clickedVehicle={clickedVehicle}
                    isActive={selectedVehicle && item.ReadingId === selectedVehicle.ReadingId}
                  />
                ))}
              </ul>
            </InfiniteScroll>
          }
        </HistoryItemsMobileWrapper>
      );
    } else {
      return (
        <HistoryItemsPCWrapper
          showButton={getShowButton()}
          historyDate={getHistoryDate()}
          close={getCloseButton()}
          infoStr={getInfo()}
          exportButton={getExportButton()}
        >

          <div
            style={{ position: "relative", overflow: "hidden" }}
            id="dvinfiniteScroll"
            className="history-wrapper history-content-fullheight perfect-scrollbar"
          >
            {items &&
              <InfiniteScroll
                dataLength={items.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={<div>Loading...</div>}
                scrollableTarget="dvinfiniteScroll"
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    <b>{items.length > 0 ? "End of records" : "No history record"}</b>
                  </p>
                }
              >
                {items.map((item) => (
                  <VehicleHistoryItemGrid
                    key={item.ReadingId}
                    item={item}
                    clickedVehicle={clickedVehicle}
                    isActive={selectedVehicle && item.ReadingId === selectedVehicle.ReadingId}
                  />
                ))}
              </InfiniteScroll>
            }
          </div>
        </HistoryItemsPCWrapper>
      );
    }
  };

  return (
    <>
      {getVehicleView()}
    </>
  );
};

export default HistoryList;
